<template>
  <v-dialog
    v-model="isDialogOpen"
    @keydown.escape="closeDialog"
    transition="slide-left"
    content-class="drawer-like"
    v-bind="$attrs">
    <v-card class="dialog-box" data-testid="create-task-dialog">
      <v-card-title class="d-flex flex-row align-center">
        <h2 class="typography-heading-lg">
          {{ t('yard.drawers.createTaskDrawer.headers.createNewTask') }}
        </h2>
        <v-spacer></v-spacer>
        <v-btn variant="text" icon="mdi-close" @click="closeDialog" />
      </v-card-title>

      <v-card-text class="dialog-body">
        <v-tabs v-model="tab" color="primary" class="custom-tabs">
          <v-tab value="move">{{ t('yard.drawers.createTaskDrawer.tabs.move') }}</v-tab>
          <!-- When we add the check task tab back, we should remove the skip from the check task tests in yard-tasks.spec.ts -->
          <v-tab value="check" disabled>
            {{ t('yard.drawers.createTaskDrawer.tabs.check') }}
            <v-chip density="comfortable" size="x-small" class="ml-2">
              {{ t('global.basicTerms.soon') }}
            </v-chip>
          </v-tab>
        </v-tabs>

        <v-tabs-window v-model="tab">
          <v-tabs-window-item value="move">
            <p
              class="typography-body-sm my-4"
              v-html="
                t(
                  'yard.drawers.createTaskDrawer.messages.moveTasksLetYardDriversRecordAMoveInRealTimeFromTheirAppOnceCompletedTheMovementIsInstantlyUpdatedInTheYardView'
                )
              "></p>

            <yard-tasks-create-move-task-form
              v-if="tab === 'move'"
              v-model="currentTaskData"
              @validate="handleValidate" />
          </v-tabs-window-item>
          <v-tabs-window-item value="check">
            <p
              class="typography-body-sm my-4"
              v-html="
                t(
                  'yard.drawers.createTaskDrawer.messages.checkTasksLetYardDriversUpdateYardViewDetailsDirectlyFromTheirAppLikeInventoryCountsAssetIDsAndSpotConditions'
                )
              "></p>

            <yard-tasks-create-check-task-form
              v-if="tab === 'check'"
              v-model="currentTaskData"
              @validate="handleValidate" />
          </v-tabs-window-item>
        </v-tabs-window>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="dialog-actions">
        <v-btn
          variant="text"
          @click="closeDialog"
          data-testid="create-check-task-dialog-action-nevermind">
          {{ t('global.buttons.nevermind') }}
        </v-btn>
        <primary-button
          :disabled="isSubmitDisabled"
          @click="createTask"
          data-testid="create-check-task-dialog-action-save">
          {{ t('global.buttons.save') }}
        </primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import { t } from '@nova/core';

import { useCreateYardTaskDrawer } from '../composables/useCreateYardTaskDrawer';
import YardTasksCreateMoveTaskForm from './YardTasksCreateMoveTaskForm.vue';
import YardTasksCreateCheckTaskForm from './YardTasksCreateCheckTaskForm.vue';

export default defineComponent({
  name: 'EventTriggeredCreateTaskDrawer',
  components: {
    YardTasksCreateMoveTaskForm,
    YardTasksCreateCheckTaskForm
  },
  setup() {
    const {
      tab,
      isDialogOpen,
      isSubmitDisabled,
      closeDialog,
      dialogProps,

      createTask,
      currentTaskData,
      handleValidate
    } = useCreateYardTaskDrawer({
      dialogEventName: 'open-create-yard-task-drawer',
      defaultTaskType: 'move'
    });

    return {
      t,
      tab,
      isDialogOpen,
      isSubmitDisabled,
      closeDialog,
      createTask,
      currentTaskData,
      handleValidate,
      dialogProps
    };
  }
});
</script>

<style scoped lang="scss">
:deep(.drawer-like) {
  width: 620px;
  max-width: 100%;
  position: fixed;
  right: 0;
  margin: 0;
  height: 100vh;
  max-height: 100%;

  .v-card {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
  }
}
</style>
